import React from 'react';
import { PaymentWerouteFailProps } from './PaymentWerouteFail.types';
import PaymentWerouteFail from './PaymentWerouteFail';

/**
 * PaymentWerouteFail 에디터용 컴포넌트
 * 에디터에서 사용되는 PaymentWerouteFail 컴포넌트의 래퍼
 */
const PaymentWerouteFailEditor: React.FC<PaymentWerouteFailProps & { isEditor?: boolean }> = (props) => {
  return <PaymentWerouteFail {...props} isEditor={true} />;
};

export default PaymentWerouteFailEditor;